import { useState } from 'react';

interface UseFeedbackModalReturn {
  isOpen: boolean;
  openModal: (initialPage?: string) => void;
  closeModal: () => void;
  initialPage: string | undefined;
}

export function useFeedbackModal(): UseFeedbackModalReturn {
  const [isOpen, setIsOpen] = useState(false);
  const [initialPage, setInitialPage] = useState<string | undefined>(undefined);

  const openModal = (page?: string) => {
    setInitialPage(page || window.location.pathname);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setInitialPage(undefined);
  };

  return {
    isOpen,
    openModal,
    closeModal,
    initialPage,
  };
} 